import React, { useEffect, useState } from "react";
import { DashboardShell } from "@/components/yc/DashboardShell";
import { api } from "@/lib/api";
import { ClipboardList, Search } from "lucide-react";

const AuditLeads = () => {
    const [data, setData] = useState({ count: 0, leads: [] });
    const [q, setQ] = useState("");

    useEffect(() => { api.get("/admin/audit-leads").then((r) => setData(r.data)); }, []);

    const filtered = data.leads.filter((l) => {
        const s = q.trim().toLowerCase();
        if (!s) return true;
        return (l.company_name || "").toLowerCase().includes(s)
            || (l.email || "").toLowerCase().includes(s)
            || (l.sector || "").toLowerCase().includes(s);
    });

    const exportCsv = () => {
        const rows = [["Company", "Email", "Sector", "Overall", "Date"]];
        for (const l of data.leads) {
            rows.push([l.company_name, l.email, l.sector, l.overall, l.created_at]);
        }
        const csv = rows.map((r) => r.map((c) => `"${String(c ?? "").replace(/"/g, '""')}"`).join(",")).join("\n");
        const blob = new Blob([csv], { type: "text/csv" });
        const url = URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.href = url;
        a.download = `curated-chaos-audit-leads-${new Date().toISOString().slice(0, 10)}.csv`;
        a.click();
        URL.revokeObjectURL(url);
    };

    return (
        <DashboardShell role="admin" title="Audit leads" subtitle="Businesses who&rsquo;ve run the free Curated Health Score audit" actions={
            <button data-testid="leads-export" onClick={exportCsv} className="yc-btn-secondary text-sm py-2 px-4">Export CSV</button>
        }>
            <div className="grid grid-cols-1 md:grid-cols-4 gap-6">
                <div className="yc-card-sm p-6" data-testid="leads-count">
                    <div className="yc-overline">Total leads</div>
                    <div className="font-heading font-black text-5xl tracking-tighter mt-2">{data.count}</div>
                </div>
                <div className="yc-card-sm p-6 md:col-span-3 flex items-center gap-3">
                    <Search className="w-5 h-5 text-yc-blue" />
                    <input data-testid="leads-search" className="yc-input" placeholder="Search company, email or sector…" value={q} onChange={(e) => setQ(e.target.value)} />
                </div>
            </div>

            <div className="yc-card overflow-hidden">
                <div className="overflow-x-auto">
                <table className="w-full text-sm min-w-[640px]">
                    <thead className="bg-yc-cream border-b-2 border-yc-ink">
                        <tr>
                            <th className="text-left p-4">Company</th>
                            <th className="text-left p-4">Email</th>
                            <th className="text-left p-4">Sector</th>
                            <th className="text-left p-4">Score</th>
                            <th className="text-left p-4">Date</th>
                        </tr>
                    </thead>
                    <tbody>
                        {filtered.map((l) => (
                            <tr key={l.lead_id} className="border-b border-yc-ink/10 hover:bg-yc-cream/40" data-testid={`lead-${l.lead_id}`}>
                                <td className="p-4 font-semibold">{l.company_name}</td>
                                <td className="p-4"><a className="text-yc-blue underline" href={`mailto:${l.email}`}>{l.email}</a></td>
                                <td className="p-4">{l.sector}</td>
                                <td className="p-4"><span className="yc-badge bg-white">{Math.round(l.overall || 0)}/100</span></td>
                                <td className="p-4 text-xs text-yc-ink/70">{new Date(l.created_at).toLocaleString()}</td>
                            </tr>
                        ))}
                        {filtered.length === 0 && (
                            <tr><td colSpan="5" className="p-12 text-center text-yc-ink/60">
                                <ClipboardList className="w-10 h-10 mx-auto opacity-40 mb-2" />
                                {data.count === 0 ? "No audit leads yet. Promote the Free Audit on the landing page." : "No matches for that search."}
                            </td></tr>
                        )}
                    </tbody>
                </table>
                </div>
            </div>
        </DashboardShell>
    );
};

export default AuditLeads;
